import { apiClient } from "../api"
import { DTO_SystemUser, NewPassword, SystemUserParams } from "./types/users"

enum Users {
  LOGGED_IN = '/logged_in_user/',
  USERS = '/users/',
  SYSTEM_USERS = '/system/user/'
}

export const updateUser = () => {
  const ac = apiClient()
  const promise = ac.get(Users.LOGGED_IN)
    .then(res => res.data)
  return promise
}

export const editUserPreferences = (data: Record<string, boolean | number | string>) => {
  const ac = apiClient()
  const promise = ac.patch(Users.LOGGED_IN, {
    preferences: { ...data }
  })
    .then(res => res.data)
  return promise
}

export const getUsers = () => {
  const ac = apiClient()
  const promise = ac.get(Users.USERS)
    .then(res => res.data)
  return promise
}

export const editUser = (id: string, data: any) => {
  const ac = apiClient()
  const promise = ac.patch(`${Users.LOGGED_IN}${id}/`, data)
    .then(res => res.data)
  return promise
}

export const changePassword = (id: string, data: NewPassword) => {
  const ac = apiClient()
  const promise = ac.post(`${Users.LOGGED_IN}${id}/change_password/`, data)
    .then(res => res.data)
  return promise
}

export const getSystemUsers = (): Promise<DTO_SystemUser[]> => {
  const ac = apiClient()
  const promise = ac.get(Users.SYSTEM_USERS)
    .then(res => res.data)
  return promise
}

export const createSystemUser = (data: SystemUserParams): Promise<DTO_SystemUser> => {
  const ac = apiClient()
  const promise = ac.post(Users.SYSTEM_USERS, {
    ...data
  }).then(res => res.data)
  return promise
}

export const updateSystemUser = (id: number, data: SystemUserParams): Promise<DTO_SystemUser> => {
  const ac = apiClient()
  const promise = ac.patch(`${Users.SYSTEM_USERS}${id}/`, {
    ...data
  }).then(res => res.data)
  return promise
}

export const deleteSystemUser = (id: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.post(`${Users.SYSTEM_USERS}${id}/set_inactive/`)
    .then(res => res.data)
  return promise
}

export const addUserFleetPermission = (id: number, fleetid: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.post(`${Users.SYSTEM_USERS}${id}/grant_fleet_access/`, {
    fleet_id: fleetid
  }).then(res => res.data)
  return promise
}

export const removeUserFleetPermission = (id: number, fleetid: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.post(`${Users.SYSTEM_USERS}${id}/revoke_fleet_access/`, {
    fleet_id: fleetid
  }).then(res => res.data)
  return promise
}
